module.exports = __webpack_public_path__ + "img/cost.b44b8da0.svg";